import { ColumnDef, ColumnSortProps } from './ExpansionTable'
import { ExpansionTableStyles } from './ExpansionTableStyles'
import {
  SortAmountDownIcon,
  SortAmountUpIcon,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@forgeglobal/design-framework'
import React, { Fragment } from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    columnSortIcon: {
      width: theme.spacing(2),
      fontSize: '1.1em',
      marginLeft: theme.spacing(0.5),
    },
    expansionTableHeader: (hasIconPadding: boolean) => ({
      height: theme.spacing(6),
      marginLeft: theme.spacing(3),
      marginRight: hasIconPadding ? theme.spacing(8.5) : theme.spacing(3),
      marginTop: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    }),
    columnHover: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
  })
)

export const ExpansionTableHeader: React.FC<{
  columnDefs: Array<ColumnDef>
  sort?: ColumnSortProps
  onClickSort?: (column: string) => void
  hasIconPadding?: boolean
}> = ({ columnDefs, sort, onClickSort, hasIconPadding }) => {
  const SortIcon = sort && (sort.direction === 'ascending' ? SortAmountUpIcon : SortAmountDownIcon)

  const onClick = (name: string) => {
    const column = columnDefs.find(col => col.name === name)
    if (column && column.sortable && onClickSort) onClickSort(name)
  }

  const tableStyle = ExpansionTableStyles(columnDefs)
  const classes = useStyles(!!hasIconPadding)

  return (
    <Typography variant="caption" color="textSecondary">
      <div className={classes.expansionTableHeader}>
        <div className={tableStyle.colSpec}>
          {columnDefs.map(({ name, text, textSecondary, sortable }) => (
            <span
              key={name}
              className={sortable ? classes.columnHover : undefined}
              onClick={onClickSort && (() => onClick(name))}>
              {text}
              {sort && name === sort.field && SortIcon && <SortIcon className={classes.columnSortIcon} />}
              {textSecondary ? (
                <Fragment>
                  <br />
                  {textSecondary}
                </Fragment>
              ) : (
                undefined
              )}
            </span>
          ))}
        </div>
      </div>
    </Typography>
  )
}
